/* Le Baroudeur du Vin : suggestions de vins du panier (page /cart et panier en volet), 13 octobre 2026.
   Le conteneur .wine-cart__upwrap porte deux adresses rendues par sections/wine-cart-upsell :
   data-wine-reco (recommandations Shopify du dernier vin ajouté) et data-wine-col (meilleures ventes,
   filtrées sur la fourchette de prix du panier). Les recommandations passent en tête, le reste est mélangé. */
(function () {
  function getList(url) {
    if (!url) return Promise.resolve([]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.wine-cart__up'));
      })
      .catch(function () { return []; });
  }

  window.wineUpsell = function (wrap, count) {
    if (!wrap || wrap.dataset.filled) return;
    wrap.dataset.filled = '1';
    Promise.all([getList(wrap.dataset.wineReco), getList(wrap.dataset.wineCol)]).then(function (lists) {
      var rest = lists[1].slice(0, 12);
      for (var i = rest.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = rest[i]; rest[i] = rest[j]; rest[j] = tmp;
      }
      var seen = {}, picked = [];
      lists[0].slice(0, count - 1).concat(rest).forEach(function (li) {
        if (picked.length < count && !seen[li.dataset.pid]) { seen[li.dataset.pid] = 1; picked.push(li); }
      });
      var ul = wrap.querySelector('[data-wine-ups]');
      ul.innerHTML = '';
      picked.forEach(function (li) { ul.appendChild(document.importNode(li, true)); });
      wrap.hidden = picked.length === 0;
    });
  };

  (window.wineUpsellQueue || []).forEach(function (args) { window.wineUpsell(args[0], args[1]); });
  window.wineUpsellQueue = [];
})();
